import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6" aria-labelledby="category-heading">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <span className="text-sm font-medium text-accent-600">CATEGORY</span>
          <h2 id="category-heading" className="mt-1 font-heading text-2xl text-foreground-900 md:text-3xl">
            漫画分类大全
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            系统梳理漫画类型大全与漫画题材分类，从热血冒险到恋爱言情，总有一类触动你的心。
          </p>
        </div>
        <Link
          to="/category"
          className="group flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
        {categories.slice(0, 10).map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative h-32 w-full overflow-hidden">
              <img
                src={cat.image}
                alt={cat.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              <span className="absolute bottom-2 left-3 flex items-center gap-1 text-sm font-medium text-white">
                <i className="ri-bookmark-line text-accent-300" />
                {cat.count} 部
              </span>
            </div>
            <div className="flex flex-1 items-center justify-between px-4 py-3">
              <div>
                <h3 className="font-medium text-foreground-900">{cat.name}</h3>
                <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">{cat.desc}</p>
              </div>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={cat.icon} />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}